import * as ng from 'angular';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {IActivationCode} from '../../../../commons/interfaces/IActivationCode';
import {IInsertActivationCodeRequest} from '../../../../commons/interfaces/insertActivationCodeRequest';
import {IListini, IProfile} from '../../../../commons/interfaces/listini';
import {IRivenditore} from '../../../../commons/interfaces/IRivenditore';

class AttivazioneClienteController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    'store',
    '$uibModal',
    '$state'
  ];

  constructor(
    // puoi definire il tipo di scope, ti aiuta il compilatore dopo con le varie proprieta
    private $scope: {
      data: IInsertActivationCodeRequest,
      dataReturn: IActivationCode,
      // questa cosa serve per evitare errori di typescript su parametri non definiti, di default ogni parametro è any
      [key: string]: any
    },
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private store: ng.a0.storage.IStoreService,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $state: any,
  ) {
    $scope.pageHeader = 'Attivazione Cliente';
    $scope.isAttivazioneCliente = true;
    $rootScope.formsubmitted = false;
    $scope.isCheckBoxPiva = true;
    $scope.isCheckBoxCodFiscale = false;
    $scope.isPiva = true;
    $scope.isCodFiscale = false;
    $scope.isProfileCodeRandom = false;
    $scope.isCheckBoxProfileCodeRandom = false;
    $scope.isActivationClient = true;
    $scope.isActivationCode = false;
    $scope.isActivationCodeError = false;

    $scope.data = {
      piva: '',
      fiscalCode: '',
      profileCode: '',
      profileCodeRandom: '',
      partnerCode1: '',
      partnerCode2: '',
      // recupera mail di chi è loggato
      requestedBy: store.get('user').accountData.email
    };


    $scope.attivazioneClienteModal = (data, size) => {

      const activationCodeModal = $uibModal.open({
        animation: true,
        component: 'codiceAttivazioneComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: () => {
            return data;
          }
        }
      });

      activationCodeModal.result.then((response) => {
        if (response.statusText === 'Internal Server Error') {
          console.error(JSON.stringify(response));
          $scope.isActivationClient = false;
          $scope.isActivationCode = false;
          $scope.isActivationCodeError = true;
          $scope.activationCodeError = response.data.errorDescription;
        } else {
          $scope.isActivationClient = false;
          $scope.isActivationCode = true;
          $scope.activationCode = $scope.formatCode(response.code);
        }

      }).catch((error) => {
        console.log(JSON.stringify(error));
      });

    };

    $scope.getReesellers = () => {
      ArchiSmallServices.getRivenditori().then((response) => {
        $scope.resellers = JSON.parse(JSON.stringify(response)) as IRivenditore[];
        $scope.resellers.sort((a, b) => a.code.localeCompare(b.code));
      }, (error) => {
        console.error(error);
      });
    };

    $scope.getReesellers();

    $scope.getListini = () => {
      ArchiSmallServices.getListini().then(response => {
        $scope.listini = JSON.parse(JSON.stringify(response)) as IListini[];
        $scope.listini.sort((a, b) => a.code.localeCompare(b.code));
      }, (error) => {
        console.error(error);
      });
    };

    $scope.getListini();

    $scope.getCodiciFECE = (code: string) => {
      ArchiSmallServices.getListini().then(response => {
        let listiniApptoggio = JSON.parse(JSON.stringify(response)) as IListini[];
        let profiliAppoggio = listiniApptoggio.filter(item => {
          return item.code === code ? item.profileList : '';
        })[0];
        if (profiliAppoggio !== undefined) {
        $scope.profiliFE =  profiliAppoggio.profileList.filter(item => item.typeLimit === 'FE');
        $scope.profiliCE =  profiliAppoggio.profileList.filter(item => item.typeLimit === 'CE');
        }
      }, (error) => {
        console.error(error);
      });
    };

    $scope.checkBoxChangedCodfiscale = () => {
      $scope.isCheckBoxCodFiscale ? $scope.enableCodfiscale() : $scope.disableCodfiscale();
    };

    $scope.enableCodfiscale = () => {
      $scope.isCodFiscale = true;
      $scope.isCheckBoxPiva = false;
      $scope.isPiva = false;
      $scope.data.fiscalCode = '';
      $scope.data.piva = '';
    };

    $scope.disableCodfiscale = () => {
      $scope.isCheckBoxPiva = true;
      $scope.enablePiva();
      $scope.data.piva = '';
      $scope.data.fiscalCode = '';
    };

    $scope.checkBoxChangedPiva = () => {
      $scope.isCheckBoxPiva ? $scope.enablePiva() : $scope.disablePiva();
    };

    $scope.enablePiva = () => {
      $scope.isPiva = true;
      $scope.isCheckBoxCodFiscale = false;
      $scope.isCodFiscale = false;
      $scope.data.piva = '';
      $scope.data.fiscalCode = '';
    };

    $scope.disablePiva = () => {
      $scope.isCheckBoxCodFiscale = true;
      $scope.enableCodfiscale();
      $scope.data.fiscalCode = '';
      $scope.data.piva = '';
    };

    $scope.checkBoxChangedProfileCodeRandom = () => {
      $scope.isCheckBoxProfileCodeRandom ? $scope.enableProfileCodeRandom() : $scope.disableProfileCodeRandom();
    };

    $scope.enableProfileCodeRandom = () => {
      $scope.isProfileCodeRandom = true;
      $scope.data.profileCodeRandom = '';
    };

    $scope.disableProfileCodeRandom = () => {
      $scope.isProfileCodeRandom = false;
      $scope.data.profileCodeRandom = '';
    };

    $scope.formatCode = (stringa: string) => {
      if ($scope.isPiva) {

        const stringa = 'P.iva cliente: ';
        const pivaCliente = $scope.data.piva;
        $scope.cliente = `${stringa} ${pivaCliente}`;

      } else if ($scope.isCodFiscale) {

        const stringa = 'Codice Fiscale Cliente:  ';
        const fisclaCodeCliente = $scope.data.fiscalCode;
        $scope.cliente = `${stringa} ${fisclaCodeCliente}`;

      }
      return stringa.replace(/(.{5})(?=.)/g, '$1-').toUpperCase();
    };

    $scope.ok = () => {
      window.location.reload();
    };

  }

}

export const AttivazioneClienteComponent: ng.IComponentOptions = {
  template: require('./attivazione-cliente.html'),
  controller: AttivazioneClienteController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/attivazione-cliente/attivazione-cliente.ts